const sectionSelector = '.sample-section';

const sectionCallBack = (sectionElement, query, queryAll) => {
    const title = query('.sample-title');
    const items = queryAll('.sample-item');

    if (title) {
        // Do something with title...
    }

    if (items.length) {
        items.forEach((el) => {
            // Per-item logic...
        });
    }
};

export { sectionSelector, sectionCallBack };
